module.exports = __webpack_public_path__ + "static/media/equal.5c5ed0dc.svg";